import { z } from 'zod'

export const ResponsibleTypeEnum = [
  'FATHER',
  'MOTHER',
  'GRANDMOTHER',
  'GRANDFATHER',
  'COUSIN',
  'AUNT',
  'UNCLE',
  'GODFATHER',
  'GODMOTHER',
  'OTHERS'
] as const

export const ResponsibleType = z.enum(ResponsibleTypeEnum)

export type ResponsibleType = (typeof ResponsibleTypeEnum)[number]

export function toResponsibleType(member: ResponsibleType) {
  return (
    {
      FATHER: 'general.common.responsibles.father',
      MOTHER: 'general.common.responsibles.mother',
      GRANDMOTHER: 'general.common.responsibles.grandmother',
      GRANDFATHER: 'general.common.responsibles.grandfather',
      COUSIN: 'general.common.responsibles.cousin',
      AUNT: 'general.common.responsibles.aunt',
      UNCLE: 'general.common.responsibles.uncle',
      GODFATHER: 'general.common.responsibles.godfather',
      GODMOTHER: 'general.common.responsibles.godmother',
      OTHERS: 'general.common.responsibles.others'
    } as const
  )[member]
}
